import { nextTick } from 'vue'

interface Line {
  start: { x: number; y: number }
  end: { x: number; y: number }
}

interface Rect {
  x: number
  y: number
  width: number
  height: number
}
interface EditRectData {
  index: number
  edit_rect_type: 'line' | 'rectangle' | 'page' | 'area'
  ignore_type: string
  isPage: boolean
  data: Array<Array<number>> | []
}

// 添加绘制模式枚举  使用时，DrawingMode.Line 为画线， DrawingMode.Rectangle 为画矩形
export enum DrawingMode {
  Line = 'line',
  Rectangle = 'rectangle',
  PageFlag = 'page'
}

// const drawingHistory = ref<Array<Line | Rect>>([]) // 所有已完成图形的统一历史记录

// 用来给全局注册事件导出的一个当前hook对象
export type UseDrawingReturn = ReturnType<typeof useDrawing>

// *
//  功能说明： 这个hook的主要功能是，初始化给父元素添加子元素 canvas，并且浮层在z轴顶部，代码中提供了，方法可设置z-index，
//         -- 然后初始化是没有给canvas，绑定画布功能，需要通过 DrawingMode 模式进行启动需要绘制的功能。
//         -- 并且可分开统计数据， 也可混合统计数据， 混合的话就是顺序序号公用。分开反之。
//         -- 最终就是为了输出实时数据，跟组件进行关联交互。 可删除绘制项。 （使用 观察者模式 + 单例状态管理）
// // 
// 当前文件核心方法
export function useDrawing(containerId: string, defaultEnabled = false ) {
  const drawingHistory = ref<Array<Line | Rect>>([]) // canvas独立数据记录
  const canvasZIndex = ref("0")
  const lines = ref<Line[]>([])
  const rects = ref<Rect[]>([])
  const pages = ref<EditRectData[]>([])
  const scale =ref<any>(1)
  
  const isDrawingEnabled = ref(defaultEnabled)  //全局处理，当前canvas是否开启绘图
  let isDrawing = false
  let startX = 0
  let startY = 0
  let currentCtx: CanvasRenderingContext2D | null = null
  let container: HTMLElement | null = null
  let canvas: HTMLCanvasElement | null = null
  const initpageFlagTextStr = ref<any>('') //记录初始化的标签内容

  const isPageFlagEnabled = ref(false)  //如果使用整页功能， 当前变量用来控制，是否禁止整页不翻译的效果
  const pageFlagColor = ref('rgba(38, 144, 225, 1)')
  const pageFlagBgColor = ref('rgba(38, 144, 225, 0.3)')
  const pageFlagText = ref<any>('')
  let currentPageIndex = 0



  // 修改指定页的canvas禁用标签
  const pageFlags = ref<Record<number, {
    text: string,
    textColor: string,
    bgColor: string
  }>>({})
  const drawingMode = ref<DrawingMode>(DrawingMode.Line) 
  // 启动开关，通过当前方法，设置不同绘制模式，并且可以处理整页禁用，恢复可操作功能，
  
  async function setDrawingMode(mode: DrawingMode, options?: {
      pageIndex?: number // 新增页码参数
      text?: string,
      textColor?: string,
      bgColor?: string
     }) {

      
    if (mode === DrawingMode.PageFlag) {
      isDrawingEnabled.value = false
      currentPageIndex = options?.pageIndex ?? 0
      
      // 更新 pageFlags 并触发数据同步
      const existingConfig = pageFlags.value[currentPageIndex]   //这个对象暂时不使用，这个对象的作用是，记录已经修改过整页禁用的数据
      const newConfig = {
        text: options?.text ||  initpageFlagTextStr.value || "",
        // text: options?.text || existingConfig?.text || initpageFlagTextStr.value || "",
        textColor: options?.textColor ?? pageFlagColor.value,
        bgColor: options?.bgColor ?? pageFlagBgColor.value
      }
      if(options?.text){
        isPageFlagEnabled.value = true
      }else{
        isPageFlagEnabled.value = false
        rects.value = []
        lines.value = []
        pages.value = [];

        // 可选：重置 pageFlags 中对应页的数据
        if (pageFlags.value[currentPageIndex]) {
          delete pageFlags.value[currentPageIndex];
        }
      }
      
      pageFlags.value[currentPageIndex] = newConfig
      
    } else {
      
      isDrawingEnabled.value = true
      isPageFlagEnabled.value = false
    }
  
    drawingMode.value = mode
    await redrawAll()
    
  }
  function importDataSetCanvasUiEndData(canvasData: {
    rects?: Rect[]
    lines?: Line[]
    pages?: EditRectData[]
  } = {},index:any) {
    // 清空现有数据
    rects.value = []
    lines.value = []
    pages.value = []
    console.log('data.rects@@@@@@@@@@@@@@===>',canvasData)
    if (canvasData && canvasData.length > 0) {
      canvasData.forEach(item => {
        if (item.edit_rect_type === 'area') {
          item.edit_rect_type = 'rectangle'
        }
        if (item.edit_rect_type === 'line') {
          const [start, end] = item.data as [[number, number], [number, number]]
          const linesObj = {
            start: { x: start[0] * scale.value, y: start[1] * scale.value },
            end: { x: end[0] * scale.value, y: end[1] * scale.value },
            ignore_type: item.ignore_type
          }
          lines.value = [...lines.value, linesObj]
          // setDrawingMode(item.edit_rect_type)
        } else if (item.edit_rect_type === 'rectangle') {
          const [topLeft, bottomRight] = item.data as [[number, number], [number, number]]
          console.log(topLeft,'bottomRight===>',bottomRight)
          const rectsObj = {
            x: topLeft[0] * scale.value,
            y: topLeft[1] * scale.value,
            width: (bottomRight[0] - topLeft[0]) * scale.value,
            height: (bottomRight[1] - topLeft[1]) * scale.value,
            ignore_type: item.ignore_type
          }
          rects.value = [...rects.value, rectsObj] // 强制更新响应式
          // setDrawingMode(item.edit_rect_type)
        
        } else if (item.edit_rect_type === 'page') {
          pages.value = [...pages.value,item]
          isPageFlagEnabled.value = true
          const pageFlagsobj = {
            text: item?.text,
            textColor: '#F09308',
            bgColor: 'rgba(252, 233, 206, 1)',
          }
          pageFlags.value[index] = pageFlagsobj
          drawingMode.value = DrawingMode.PageFlag
          // setDrawingMode(DrawingMode.PageFlag, pageFlagsobj)
        }
      })
    }
    // 如果有传入则赋值
    console.log('pages.value~~~~~~~',pages.value)
    nextTick(()=>{
      // 触发重绘
      redrawAll()
    })
    
  }
  // 可重置某一页，整页是否禁用状态，辅助方法， 暂未使用
  function resetPageFlag(pageIndex: number) {
    if (pageFlags.value[pageIndex]) {
      delete pageFlags.value[pageIndex]
    }
    redrawAll()
  }
  async function clearPageFlag(pageIndex:any) {
    isPageFlagEnabled.value = false
    isDrawingEnabled.value = true
    // pageFlags.value[pageIndex] = {} as any
    pages.value = []
    setDrawingMode(DrawingMode.PageFlag,{
      pageIndex:pageIndex
    })
    await redrawAll()
    exportAllData()
  }
  // 设置canvas 在父容器中的的z轴
  function setCanvasZIndex(zIndex: string) {
    canvasZIndex.value = zIndex
    if (canvas) {
      canvas.style.zIndex = zIndex.toString()
    }
  }
  // 辅助方法，由这里统一管理绘制方法
  function setupEventListeners() {
    if (!container || !isDrawingEnabled.value) return
    // console.log('所有页绑定事件成功～～～')
    container.addEventListener('mousedown', onMouseDown)
    container.addEventListener('mousemove', onMouseMove)
    container.addEventListener('mouseup', onMouseUp)
  }
  // 清除绘制方法
  function removeEventListeners() {
    if (!container) return
    container.removeEventListener('mousedown', onMouseDown)
    container.removeEventListener('mousemove', onMouseMove)
    container.removeEventListener('mouseup', onMouseUp)
  }

  // 给canvas 挂载绘制方法。允许绘制
  function toggleDrawing(enabled: boolean) {
    // console.log('toggleDrawing===挂载事件成功', enabled)
    isDrawingEnabled.value = enabled
    if (enabled) {
      setupEventListeners()
    } else {
      removeEventListeners()
    }
  }

  watchEffect(() => {
    if (container && isDrawingEnabled.value) {
      setupEventListeners()
    } else {
      removeEventListeners()
    }
  })


  // 初始化，生成canvas，绘制元素，以及初始化的整页默认标签
  function init(
    height:any,
    width:any,
    initPageFlagText?:string,
    pageIndex = 0,
    scaleParam?:any,
    callback?: () => void
  ) {
   
    currentPageIndex = pageIndex
    scale.value = scaleParam
    // console.log(`init-containerId-获取到pdf每一页的父元素-id-并且给元素创建透明canvas ${containerId}`)

    container = document.getElementById(containerId)

    if(initPageFlagText){
      pageFlagText.value = initPageFlagText
      initpageFlagTextStr.value = initPageFlagText
    }

    
    if (!container) return
    // 创建绘图画布层
    canvas = document.createElement('canvas')
    canvas.style.position = 'absolute'
    canvas.style.top = '0'
    canvas.style.left = '0'
    canvas.style.pointerEvents = 'auto'
    canvas.style.zIndex = canvasZIndex.value
    canvas.width = width || container.clientWidth
    canvas.height = height || container.clientHeight
    container.appendChild(canvas)

    currentCtx = canvas.getContext('2d')
    if (currentCtx) {
      currentCtx.strokeStyle = 'rgba(38, 144, 225, 1)'
      currentCtx.lineWidth = 2
    }

     // 如果有该页配置，则使用, 初始化配置标签样式以及内容
    const defaultConfig = {
      text: pageFlagText.value ?? '',
      textColor: pageFlagColor.value,
      bgColor: pageFlagBgColor.value
    }
    pageFlags.value[pageIndex] = defaultConfig

    isDrawingEnabled.value = true
    isPageFlagEnabled.value = false
    drawingMode.value = DrawingMode.Rectangle
    toggleDrawing(true)

    nextTick(() => {
      redrawAll()
      callback?.()
    })
  }

  // 替代 onBeforeUnmount
  function destroy() {
    removeEventListeners()
    if (canvas && container) {
      container.removeChild(canvas)
    }
    // 清理资源
    container = null
    canvas = null
    currentCtx = null
  }

  function initCanvas () {
    if(!container){
      container = document.getElementById(containerId)
      if(container){
        // 创建绘图画布层
        canvas = document.createElement('canvas')
        canvas.style.position = 'absolute'
        canvas.style.top = '0'
        canvas.style.left = '0'
        canvas.style.pointerEvents = 'auto'
        canvas.style.zIndex = '20'
        canvas.width = container.clientWidth
        canvas.height = container.clientHeight
        container.appendChild(canvas)

        currentCtx = canvas.getContext('2d')
        if (currentCtx) {
          currentCtx.strokeStyle = 'rgba(38, 144, 225, 1)'
          currentCtx.lineWidth = 2
        }
      }
    }
  }

  function onMouseDown(e: MouseEvent) {
    // console.log('onMouseDown——按下', e)
    if (!isDrawingEnabled.value) return
    isDrawing = true
    const rect = container!.getBoundingClientRect()
    startX = e.clientX - rect.left
    startY = e.clientY - rect.top

    // 设置光标为十字型
    if (container) {
      container.style.cursor = 'crosshair'
    }
  }

  let tempLine: Line | null = null
  function onMouseMove(e: MouseEvent) {
    // console.log('onMouseMove——滑动', e)
    if (!isDrawingEnabled.value || !isDrawing || !currentCtx) return
    const rect = container!.getBoundingClientRect()
    const endX = e.clientX - rect.left
    const endY = e.clientY - rect.top

    if (isDrawing && drawingMode.value === DrawingMode.Rectangle) {
      // 实时绘制矩形预览
      draw(startX, startY, endX, endY)
    } else if (isDrawing && drawingMode.value === DrawingMode.Line) {
      tempLine = { start: { x: startX, y: startY }, end: { x: endX, y: endY } }
      // 原始线条逻辑保持不变
      draw(startX, startY, endX, endY)
    }
  }

  function onMouseUp(e: MouseEvent) {
    // console.log('onMouseUp——抬起', e)
    if (!isDrawingEnabled.value || !isDrawing || !currentCtx) return

    const rect = container!.getBoundingClientRect()
    const endX = e.clientX - rect.left
    const endY = e.clientY - rect.top

    const length = getLineLength(startX, startY, endX, endY)

    let currentDrawing: Line | Rect | null = null
    
    if (drawingMode.value === DrawingMode.Line && length > 10) {
      lines.value.push({
        start: { x: startX, y: startY },
        end: { x: endX, y: endY },
      })
      currentDrawing = {
        start: { x: startX, y: startY },
        end: { x: endX, y: endY }
      }
      
    } else if (drawingMode.value === DrawingMode.Rectangle) {
      const width = Math.abs(endX - startX)
      const height = Math.abs(endY - startY)
      // 最终输出给后台的数据是 {x,y,x+w,y+h}
      if (width > 10 && height > 10) {
        rects.value.push({
          x: Math.min(startX, endX),
          y: Math.min(startY, endY),
          width,
          height,
        })
        currentDrawing = {
          x: Math.min(startX, endX),
          y: Math.min(startY, endY),
          width,
          height
        }
      }
    }

    if (currentDrawing) {
      drawingHistory.value.push(currentDrawing)
    }

    tempLine = null
    isDrawing = false
    redrawAll()

    // 恢复默认光标
    if (container) {
      container.style.cursor = 'default'
    }
  }
  // 这个旧的方法是，线跟矩形一起画，已经废弃
  // function draw(x1: number, y1: number, x2: number, y2: number) {
  //   if (!currentCtx) return
  //   currentCtx.clearRect(0, 0, canvas!.width, canvas!.height)
  //   currentCtx.beginPath()
  //   currentCtx.moveTo(x1, y1)
  //   currentCtx.lineTo(x2, y2)
  //   currentCtx.stroke()
  // }
  
  // 实时绘制方法
  function draw(startX: number, startY: number, endX: number, endY: number) {
    if (!currentCtx || !container) return

    // 清除画布
    currentCtx.clearRect(0, 0, canvas!.width, canvas!.height)

    currentCtx.beginPath()
    lines.value.forEach(line => {
      currentCtx.moveTo(line.start.x, line.start.y)
      currentCtx.lineTo(line.end.x, line.end.y)
    })
    currentCtx.stroke()
    
    // 如果是画线模式 → 实时绘制当前线段（预览）
    if (drawingMode.value === DrawingMode.Line && tempLine) {
      currentCtx.beginPath()
      currentCtx.moveTo(tempLine.start.x, tempLine.start.y)
      currentCtx.lineTo(tempLine.end.x, tempLine.end.y)
      currentCtx.strokeStyle = 'rgba(38, 144, 225, 1)'
      currentCtx.lineWidth = 2
      currentCtx.stroke()
    }

    // 画虚线矩形预览
    let tempRect: Rect | null = null
    if (drawingMode.value === DrawingMode.Rectangle && isDrawing) {
      const width = Math.abs(endX - startX)
      const height = Math.abs(endY - startY)
      if (width > 5 && height > 5) {
        currentCtx.setLineDash([5, 5])
        currentCtx.strokeStyle = 'rgba(38, 144, 225, 1)'
        currentCtx.strokeRect(startX, startY, endX - startX, endY - startY)
        currentCtx.setLineDash([])

        tempRect = { x: startX, y: startY, width, height }
      }
    }

    // 画已有矩形（实线 + 背景）
    // currentCtx.setLineDash([5, 5])
    rects.value.forEach(rect => {
      drawRectWithBackground(rect.x, rect.y, rect.width, rect.height)
    })
    // currentCtx.setLineDash([])

    // 如果正在画线 → 添加中间标签
    // if (isDrawing && drawingMode.value === DrawingMode.Line) {
    //   const midX = (startX + endX) / 2
    //   const midY = (startY + endY) / 2
    //   const index = lines.value.length + 1 // 当前线段编号为下一条线段序号
    //   drawLabelAt(midX, midY, String(index))
    // }

    // 如果正在画矩形 → 添加左上角标签
    if (isDrawing && drawingMode.value === DrawingMode.Rectangle && tempRect) {
      const index = rects.value.length + 1
      drawLabelAt(tempRect.x, tempRect.y, String(index))
    }
  }
  // 线段长度判断，保留有效线段
  function getLineLength(startX: number, startY: number, endX: number, endY: number): number {
    return Math.sqrt((endX - startX) ** 2 + (endY - startY) ** 2)
  }

  // 绘制带背景的矩形
  function drawRectWithBackground(x: number, y: number, width: number, height: number) {
    if (!currentCtx) return

    // 填充背景（红色透明度 0.3）
    currentCtx.fillStyle = 'rgba(38, 144, 225, 0.3)'
    currentCtx.fillRect(x, y, width, height)

    // 边框颜色 实线
    // currentCtx.strokeStyle = '#FF0000'
    // currentCtx.lineWidth = 2
    // currentCtx.strokeRect(x, y, width, height)
    // 虚线
    currentCtx.setLineDash([5, 5])
    currentCtx.strokeStyle = 'rgba(38, 144, 225, 1)'
    currentCtx.strokeRect(x, y, width, height)
    currentCtx.setLineDash([])
  }

  // 鼠标抬起后绘制方法，画线，画矩形，最终方法
  async function redrawAll() {

    if (!currentCtx) return

    currentCtx.clearRect(0, 0, canvas!.width, canvas!.height)

    // 如果是 PageFlag 模式，并且当前页有配置才绘制标签
    const flagConfig = pageFlags.value[currentPageIndex]
    console.log('flagConfig==>',flagConfig)
    // 如果是 PageFlag 模式，只绘制标签
    if ((drawingMode.value === DrawingMode.PageFlag&& flagConfig ) ) {
    // if ((drawingMode.value === DrawingMode.PageFlag&& flagConfig ) || isPageFlagEnabled.value) {
      await drawPageFlagLabel(
        flagConfig?.text ?? initpageFlagTextStr.value,
        flagConfig?.textColor ?? pageFlagColor.value,
        flagConfig?.bgColor ?? pageFlagBgColor.value
      )
      
      emitDrawingChange(drawingMode.value)
      return
    }
    // 2. 如果不是 PageFlag 模式，但该页有整页配置 → 继续绘制图形和标签，但不覆盖整页配置
    if ( flagConfig) {
      await drawPageFlagLabel(
        flagConfig.text,
        flagConfig.textColor,
        flagConfig.bgColor
      )
      // 注意：不要 return，继续绘制其他图形
    }

    // 画线段
    currentCtx.beginPath()
    lines.value.forEach(( line,index) => {
      currentCtx.moveTo(line.start.x, line.start.y)
      currentCtx.lineTo(line.end.x, line.end.y)
      currentCtx.stroke()

      // 画线段中间标签
      const midX = (line.start.x + line.end.x) / 2
      const midY = (line.start.y + line.end.y) / 2
      drawLabelAt(midX, midY, String(index + 1),false)
    })

    // 绘制矩形（带背景）
    rects.value.forEach( (rect,index) => {
      drawRectWithBackground(rect.x, rect.y, rect.width, rect.height)
      drawLabelAt(rect.x, rect.y, String(index + 1)) // 左上角显示序号
    })

    // 重新绘制所有图形, 这个方法是共享标签顺序。
    // drawingHistory.value.forEach((item, index) => {
    //   const label = String(index + 1)

    //   if ('start' in item && 'end' in item) {
    //     // 绘制线段
    //     currentCtx.beginPath()
    //     currentCtx.moveTo(item.start.x, item.start.y)
    //     currentCtx.lineTo(item.end.x, item.end.y)
    //     currentCtx.strokeStyle = '#FF0000'
    //     currentCtx.lineWidth = 2
    //     currentCtx.stroke()

    //     // 线段中间标签
    //     const midX = (item.start.x + item.end.x) / 2
    //     const midY = (item.start.y + item.end.y) / 2
    //     drawLabelAt(midX, midY, label)
    //   } else if ('x' in item && 'y' in item && 'width' in item && 'height' in item) {
    //     // 绘制矩形
    //     drawRectWithBackground(item.x, item.y, item.width, item.height)

    //     // 矩形左上角标签
    //     drawLabelAt(item.x, item.y, label)
    //   }
    // })
    // console.log('是否发布通知',drawingMode.value)
    // 添加通知监听器的逻辑
    emitDrawingChange(drawingMode.value)
  }
  const drawingChangeCallbacks = ref<((eventType: any) => void)[]>([])

  // 这里传实参， 通知数据更改，发布
  function emitDrawingChange(eventType) {
    drawingChangeCallbacks.value.forEach(cb => cb(eventType))
  }

  // 提供给外部注册回调的方法
  function onDrawingChange(callback: (eventType:any) => void) {
    drawingChangeCallbacks.value.push(callback)
  }

  const labelStyle = {
    bgColor: 'rgba(38, 144, 225, 0.3)',
    textColor: '#fff',
    fontSize: 16,
    padding: 5,
    borderRadius: 5
  }

  // 用于在指定坐标绘制数字标签
  function drawLabelAt(x: number, y: number, text: string, withBorder = true) {
    if (!currentCtx) return

    const fontSize = labelStyle.fontSize
    const padding = labelStyle.padding
    const borderRadius = labelStyle.borderRadius
    const labelWidth = currentCtx.measureText(text).width + padding * 2
    const labelHeight = fontSize + padding * 2

    // 绘制圆角矩形背景（rgba 支持透明）
    currentCtx.fillStyle = labelStyle.bgColor
    roundRect(currentCtx, x - labelWidth / 2, y - labelHeight / 2, labelWidth, labelHeight, borderRadius)
    currentCtx.fill()

     // 只有需要边框时才绘制 strokeRect
    if (withBorder) {
      currentCtx.strokeStyle = 'rgba(38, 144, 225, 1)'
      currentCtx.lineWidth = 1
      roundRect(currentCtx, x - labelWidth / 2, y - labelHeight / 2, labelWidth, labelHeight, borderRadius)
      currentCtx.stroke()
    }
    // 绘制文本
    currentCtx.fillStyle = labelStyle.textColor
    currentCtx.font = `${fontSize}px sans-serif`
    currentCtx.textAlign = 'center'
    currentCtx.textBaseline = 'middle'
    currentCtx.fillText(text, x, y)
  }
  // 辅助方法，绘制圆角矩形，
  function roundRect(ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, radius: number) {
    ctx.beginPath()
    ctx.moveTo(x + radius, y)
    ctx.lineTo(x + width - radius, y)
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
    ctx.lineTo(x + width, y + height - radius)
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
    ctx.lineTo(x + radius, y + height)
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
    ctx.lineTo(x, y + radius)
    ctx.quadraticCurveTo(x, y, x + radius, y)
    ctx.closePath()
  }
  const pageFlagLabelStyle = {
    bgColor: 'rgba(38, 144, 225, 0.3)',
    textColor: 'rgba(38, 144, 225, 1)',
    fontSize: 12,
    padding: { y: 5, x: 10 },
    borderRadius: 5
  }
  // 绘制整页的canvas左上角标签
  function drawPageFlagLabel(text: string, textColor: string, bgColor: string) {
    if (!currentCtx || !canvas) return

    const fontSize = pageFlagLabelStyle.fontSize
    const padding = pageFlagLabelStyle.padding
    const borderRadius = pageFlagLabelStyle.borderRadius
    const labelWidth = currentCtx.measureText(text).width + padding.x * 2
    const labelHeight = fontSize + padding.y * 2

    const x = padding.x
    const y = padding.y + 20  //标签向下偏移20px

    // 绘制左上角圆角背景（左下和右下有圆角）
    roundRectWithBottomRounded(currentCtx, x, y, labelWidth, labelHeight, borderRadius)
    currentCtx.fillStyle = bgColor
    currentCtx.fill()

    // 绘制文字
    currentCtx.fillStyle = textColor
    currentCtx.font = `${fontSize}px sans-serif`
    currentCtx.textAlign = 'center'
    currentCtx.textBaseline = 'middle'
    currentCtx.fillText(text, x + labelWidth / 2, y + labelHeight / 2)
  }
  // 辅助函数：绘制左下和右下带圆角的矩形
  function roundRectWithBottomRounded(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    radius: number
  ) {
    ctx.beginPath()
    ctx.moveTo(x, y) // 左上角起点
    ctx.lineTo(x + width, y) // 右上角
    ctx.lineTo(x + width, y + height - radius) // 接近右下角
    ctx.quadraticCurveTo(
      x + width,
      y + height,
      x + width - radius,
      y + height
    ) // 右下角圆角
    ctx.lineTo(x + radius, y + height) // 移动到左下角附近
    ctx.quadraticCurveTo(
      x,
      y + height,
      x,
      y + height - radius
    ) // 左下角圆角
    ctx.closePath()
  }

  // 撤销
  function undo() {
    if (rects.value.length > 0) {
      rects.value.pop()
    } else if (lines.value.length > 0) {
      lines.value.pop()
    }
    redrawAll()
  }
  // 导出独立的画线，和矩形 操作数据
  function exportData() {

    const lineData = lines.value.map(line => ({
      start: [line.start.x, line.start.y],
      end: [line.end.x, line.end.y]
    }));

    const rectData = rects.value.map(rect => ({
      x: rect.x,
      y: rect.y,
      x1: rect.x + rect.width,
      y1: rect.x + rect.height
    }));
    
    console.log('线条数据:', lineData)
    console.log('矩形数据:', rectData)
    return {
      lines: lineData,
      rects: rectData
    }
  }


 
  async function exportAllData(): Promise<EditRectData[]> {
    // console.log('查看导出数据日志==>>',currentPageIndex,'drawingMode.value==>>',drawingMode.value,pageFlags.value[currentPageIndex])
    let result: EditRectData[] = [...pages.value]
    // 判断是否启用 PageFlag 模式
    if (drawingMode.value === DrawingMode.PageFlag) {
      
      const flagConfig = pageFlags.value[currentPageIndex]
      if(flagConfig?.text && isPageFlagEnabled.value){
        pages.value = pages.value.filter(p => p.index !== currentPageIndex)
        
        // 添加新数据
        const newPageData = {
          index: 1,
          edit_rect_type: DrawingMode.PageFlag,
          ignore_type: pages.value[0]?.ignore_type || 'all',
          isPage: isPageFlagEnabled.value,
          data: []// 表示整页禁用，线段和矩形无效
        }
        pages.value = [newPageData]
        result = [...pages.value]
      }else{
        const newPageData = {
          index: 1,
          edit_rect_type: DrawingMode.PageFlag,
          ignore_type: pages.value[0]?.ignore_type || 'all',
          isPage: isPageFlagEnabled.value,
          data: []// 表示整页禁用，线段和矩形无效
        }
        pages.value = []
        result = []
      }
      
    } else {
      // 这是混合顺序的代码
      // 导出线段数据
      // const lineData = drawingHistory.value
      //   .filter(item => 'start' in item)
      //   .map((line, index) => ({
      //     index: index + 1,
      //     edit_rect_type: DrawingMode.Line as const,
      //     ignore_type: 'all',
      //     data: [
      //       [(line as Line).start.x, (line as Line).start.y],
      //       [(line as Line).end.x, (line as Line).end.y]
      //     ]
      //   }))
      // // 导出矩形数据
      // const rectData = drawingHistory.value
      //   .filter(item => 'x' in item)
      //   .map((rect, index) => ({
      //     index: index + 1,
      //     edit_rect_type: DrawingMode.Rectangle as const,
      //     ignore_type: 'all',
      //     data: [
      //       [(rect as Rect).x, (rect as Rect).y],
      //       [(rect as Rect).x + (rect as Rect).width, (rect as Rect).y + (rect as Rect).height]
      //     ]
      //   }))

      // 使用当前实例的 lines 和 rects
      const lineData = lines.value.map((line, index) => ({
        
        index: index + 1,
        edit_rect_type: DrawingMode.Line as const,
        ignore_type: line?.ignore_type || 'all',
        data: [
          [line.start.x/scale.value, line.start.y/scale.value],
          [line.end.x/scale.value, line.end.y/scale.value]
        ],
        isPage: false // 
      }))

      const rectData = rects.value.map((rect, index) => ({
        index: index + 1,
        edit_rect_type: DrawingMode.Rectangle as const,
        ignore_type: rect?.ignore_type || 'all',
        data: [
          [(rect.x/scale.value), (rect.y/scale.value)],
          [(rect.x + rect.width)/scale.value, (rect.y + rect.height)/scale.value]
        ],
        isPage: false // 
      }))
  
      result.push(...lineData, ...rectData)
    }
  
    // console.log('导出数据:', result)
    return result
  }
  
  /**
 * 更新指定索引的图形的 ignore_type 字段
 * @param index 图形序号（从 1 开始）
 * @param ignoreType 新的 ignore_type 值
 */
function updateShapeIgnoreType(modeType:any ,index: number, ignoreType: string) {
  const lineIndex = index 
  const rectIndex = index 
  const pageIndex = index 

  if (lines.value[lineIndex] && modeType == DrawingMode.Line) {
    
    if (lines.value[lineIndex].ignore_type) {
      lines.value[lineIndex].ignore_type = ignoreType
    }else{
      lines.value[lineIndex]['ignore_type'] = ignoreType
    }

  } else if (rects.value[rectIndex] && modeType == DrawingMode.Rectangle) {
    
    if (rects.value[rectIndex].ignore_type) {
      rects.value[rectIndex].ignore_type = ignoreType
    }else{
      rects.value[rectIndex]['ignore_type'] = ignoreType
    }

  } else if (pages.value[pageIndex] && modeType == DrawingMode.PageFlag) {
    console.log('pages.value==init==',pages.value)
    
    if (pages.value[pageIndex].ignore_type) {
      pages.value[pageIndex].ignore_type = ignoreType
    }else{
      pages.value[pageIndex]['ignore_type'] = ignoreType
    }
  }else {
    console.warn(`No shape found at index ${index}`)
  }

  // exportAllData() // 强制更新数据并触发 redraw
}

  return {
    lines,
    rects,
    pages,
    scale,
    pageFlags,
    drawingMode,
    redrawAll,
    undo,
    isDrawingEnabled,
    toggleDrawing,
    init,         // 手动初始化
    destroy,       // 手动销毁
    setDrawingMode,
    exportData,
    exportAllData,
    setCanvasZIndex,
    isPageFlagEnabled,
    resetPageFlag,
    clearPageFlag,
    onDrawingChange,
    updateShapeIgnoreType,
    importDataSetCanvasUiEndData
  }
}